<div class="main-content">
    <div class="container-fluid">
        <div class="row">
            <div class="col-md-12">
                <div class="card">
                    <div class="card-header card/-header-primary card-header-icon">
                        <div class="card-icon">
                            <i class="material-icons">assignment</i>
                        </div>
                        <h4 class="card-title">Vendors List</h4>
                    </div>
                    <div class="card-body">
                        <div class="toolbar">
                            <div class="row">
                                <div class="col-md-12" style="text-align: right;">
        
                                    <button (click)="openNuevoPaciente()" mat-raised-button class="btn btn-success">
                                        <span class="btn-label">
                                          <i class="material-icons">person_add</i>
                                        </span>
                                         New Vendor
                                      </button>
        
                                      &nbsp;&nbsp;
                      
                                    <button type="button" class="btn btn-outline-{{activos === 1 ? 'info' : 'danger'}}" (click)="cambiarActivos()">
                                      <i class="fa fa-eye" aria-hidden="true"></i> Show {{activos === 1 ? 'Inactive' : 'Active'}} Vendors
                                    </button>
                                </div>
                              </div>
                        </div>

                        <div *ngIf="cargando" style="text-align: center">
                            <h2><b><i class="fa fa-spinner fa-pulse fa-3x fa-fw"></i> Loading...</b></h2>
                          </div>
                        <div [hidden]="cargando" class="material-datatables">
                            <table id="datatables" class="table table-striped table-no-bordered table-hover" cellspacing="0" width="100%" style="width:100%">
                                <thead>
                                    <tr>

                                        <th>Rep Name</th>
                                        <th>Company Name</th>
                                        <th>Title</th>
                                        <th>Name</th>
                                        <th>City</th>
                                        <th>Status</th>
                                        <th class="disabled-sorting text-right">Actions</th>
                                    </tr>
                                </thead>

                                <tbody>
                                    <tr id="user{{item.id}}" *ngFor="let item of pacientes">

                                        <td>{{item.managedByString}}</td>
                                        <td>{{item.companyLinked != null ? item.companyLinked.name : ''}}</td>
                                        <td>{{item.ocupation}}</td>
                                        <td>{{item.name + ' ' + item.surname}}</td>
                                        <td>{{item.city}}</td>
                                        <td>
                                            <button class="btn {{item.activo == 1 ? 'btn-success' : 'btn-danger'}} btn-sm" (click)="deleteFolderfirst(item.id)">
                                              <i class="material-icons">power_settings_new</i> &nbsp; <span>{{item.activo == 1 ? 'Active' : 'Inactive'}}</span>
                                            </button>
                                        </td>
                                        <td class="text-right">
                                            <a [routerLink]="['/pages/user', item.id]" class="btn btn-link btn-info btn-just-icon"><i class="material-icons">remove_red_eye</i></a>

                                            <!-- <a (click)="deleteFolderfirst(item.id)" class="btn btn-link btn-danger btn-just-icon"><i class="material-icons">close</i></a> -->
                                        </td>
                                    </tr>
                                </tbody>
                            </table>
                            <input type="hidden" name="borrarUser" value="" id="borrarUser" (click)="deleteUser()">
                        </div>
                    </div>
                    <!-- end content-->
                </div>
                <!--  end card  -->
            </div>
            <!-- end col-md-12 -->
        </div>
        <!-- end row -->
    </div>
</div>